export enum LogicEnum {
  AND = 'and',
  OR = 'or',
}
